export default "__VITE_ASSET__BmjS1eKl__"